import type { LoginResponse } from '@ferty9/types';
import { authHeaders, jsonPostInit, requestJson } from './client';

export interface LoginPayload {
  username: string;
  password: string;
}

export function login(payload: LoginPayload): Promise<LoginResponse> {
  return requestJson<LoginResponse>('/api/auth/login', jsonPostInit(payload));
}

export function getCurrentUser(token?: string): Promise<Pick<LoginResponse, 'user'>> {
  return requestJson<Pick<LoginResponse, 'user'>>('/api/auth/me', {
    headers: authHeaders(token),
  });
}

export function logout(token?: string): Promise<{ success: boolean }> {
  return requestJson<{ success: boolean }>('/api/auth/logout', jsonPostInit({}, token));
}

export type RecoveryChannel = 'email' | 'whatsapp';
export interface RecoveryMethod { channel: RecoveryChannel; maskedDestination: string }
export function beginPasswordRecovery(identifier: string) { return requestJson<{ success: true; challengeToken: string; methods: RecoveryMethod[]; message: string }>('/api/auth/password-recovery/begin', jsonPostInit({ identifier })); }
export function sendPasswordRecoveryOtp(challengeToken: string, channel: RecoveryChannel) { return requestJson<{ success: true; message: string }>('/api/auth/password-recovery/send-otp', jsonPostInit({ challengeToken, channel })); }
export function completePasswordRecovery(payload: { challengeToken: string; channel: RecoveryChannel; otp: string; newPassword: string; confirmPassword: string }) { return requestJson<{ success: true; message: string }>('/api/auth/password-recovery/complete', jsonPostInit(payload)); }
